import { FC, useState } from "react";
import { useSound } from "../../../../hooks";
import { CardType } from "../../../../util/enums";

interface InfoButtonProps {
	clickHandler(): void;
	cardType: CardType;
	solutionCardsInHands?: boolean;
}

const InfoButton: FC<InfoButtonProps> = (props) => {
	const { clickHandler, cardType, solutionCardsInHands } = props;
	const [isButtonActive, setIsButtonActive] = useState(false);
	
	const {playSound} = useSound();

	const handleClick = () => {
		clickHandler();
		playSound("/sounds/LightClick.mp3");
		setIsButtonActive(!isButtonActive);
	}

	const solutionCardType = () => {
        switch (cardType) {
			case (CardType.JOKER_SOLUTION):
				return "emotional";
			case (CardType.EMOTIONAL_SOLUTION):
				return "emotional";
            case (CardType.SOCIAL_SOLUTION):
                return "social";
			case (CardType.MENTAL_SOLUTION):
					return "mental";
			case (CardType.PHYSICAL_SOLUTION):
				return "physical";
			case (CardType.STRENGTH):
				return "strength";
        };
    }

	const getInfoButtonSize = () => {
		if (solutionCardsInHands) return "info_button_size_cards_in_hands";
		return "info_button_size";
	}

	return (
		<div className="info_button" onClick={() => handleClick()}>
			{isButtonActive ?
				<div className={`info_button_icon_active_${solutionCardType()} ${getInfoButtonSize()} `}/>
				:
				<div className={`info_button__icon ${solutionCardType()} ${getInfoButtonSize()} `} />
			}
		</div>
	);
};

export default InfoButton;

